import React, { useEffect, useRef, useState } from 'react';

// Reusable smooth hero: instant gradient placeholder, fade-in on load,
// then a gentle crossfade rotation through the provided images.
// Pass a single image for fade-in only (no rotation).
export const SmoothHero = ({ images, interval = 9000, alt = '', className = '', children }) => {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * images.length));
  const [loaded, setLoaded] = useState(false);
  const [prevIndex, setPrevIndex] = useState(null);
  const timer = useRef(null);

  useEffect(() => {
    const img = new Image();
    img.onload = () => setLoaded(true);
    img.src = images[index];
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!loaded || images.length < 2) return;
    timer.current = setInterval(() => {
      setIndex((cur) => {
        const next = (cur + 1) % images.length;
        const pre = new Image();
        pre.src = images[(next + 1) % images.length];
        setPrevIndex(cur);
        return next;
      });
    }, interval);
    return () => clearInterval(timer.current);
  }, [loaded, images, interval]);

  return (
    <div className={`relative overflow-hidden bg-gradient-to-br from-slate-800 via-slate-700 to-slate-900 ${className}`} data-testid="smooth-hero">
      {prevIndex !== null && (
        <img
          key={`prev-${prevIndex}`}
          src={images[prevIndex]}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover"
        />
      )}
      <img
        key={`cur-${index}`}
        src={images[index]}
        alt={alt}
        className="absolute inset-0 w-full h-full object-cover transition-opacity duration-[1500ms] ease-out"
        style={{ opacity: loaded ? 1 : 0 }}
        onLoad={() => setLoaded(true)}
      />
      {children}
    </div>
  );
};

export default SmoothHero;
